import React, { useEffect, useState } from 'react'
import PropTypes from 'prop-types';
import Box from '@mui/material/Box';
import Collapse from '@mui/material/Collapse';
import IconButton from '@mui/material/IconButton';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import TablePagination from '@mui/material/TablePagination';
import Typography from '@mui/material/Typography';
import Paper from '@mui/material/Paper';
import Select from '@mui/material/Select';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import InputLabel from '@mui/material/InputLabel';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import KeyboardArrowUpIcon from '@mui/icons-material/KeyboardArrowUp';
import ReceiptIcon from '@mui/icons-material/Receipt';
import useReceiptIssue from './useReceiptIssue';
import ImageModalSlider from '../../sharedComponents/ImageModalSlider';
import Modal from 'react-modal';
import { formatDate } from '../../utils/dateUtils';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import { toast } from 'react-toastify';
import { formatAmount } from '../../utils/formatAmount';

const customStyles = {
  overlay: {
    backgroundColor: 'rgba(0, 0, 0, 0.75)' // This sets the overlay color
  },
  content: {
    top: '50%',
    left: '50%',
    right: 'auto',
    bottom: 'auto',
    height: 'auto',
    width: '500px',
    marginRight: '-50%',
    transform: 'translate(-50%, -50%)',
  },
};

const ReceiptIssue = () => {

  const { receiptIssues, total, adminList, getAdminList, getIncompleteIssue, updateDoneStatus } = useReceiptIssue()
  const [imageUrls, setImageUrls] = useState()
  const [modalIsOpen, setModalIsOpen] = useState(false);
  const [page, setPage] = useState(0); // MUI TablePagination is 0-indexed
  const [rowsPerPage, setRowsPerPage] = useState(20);
  const [adminFilter, setAdminFilter] = useState('');

  const fetchData = (pageNum, rows, admin) => {
    getIncompleteIssue({ page: pageNum + 1, limit: rows, admin });
  };

  useEffect(() => {
    getAdminList();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    fetchData(page, rowsPerPage, adminFilter);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [page, rowsPerPage, adminFilter]);

  const handleAdminChange = (e) => {
    setPage(0);
    setAdminFilter(e.target.value);
  };

  const handlePageChange = (_, newPage) => {
    setPage(newPage);
  };

  const handleRowsPerPageChange = (e) => {
    setRowsPerPage(parseInt(e.target.value, 10));
    setPage(0);
  };

  const openImageSlider = async (receipts) => {
    if(receipts){
      const receiptUrls = receipts.map((receipt) => (receipt.imageUrl))
      setImageUrls(receiptUrls)
    }
    setModalIsOpen(true)
  };

  const closeImageSlider = () =>{
    setModalIsOpen(false)
  }

  const doneIconClick = async (receiptId) => {
    const result = await updateDoneStatus({receiptId})
    if(result){
      toast.success("Update Successfully")
      fetchData(page, rowsPerPage, adminFilter)
    }else{
      toast.error("Update Fail")
    }
  }

  function Row({issue}) {
    const [open, setOpen] = React.useState(false);
    return (
      <React.Fragment>
        <TableRow sx={{ '& > *': { borderBottom: 'unset' } }}>
          <TableCell>
            <IconButton
              aria-label="expand row"
              size="small"
              onClick={() => setOpen(!open)}
            >
              {open ? <KeyboardArrowUpIcon /> : <KeyboardArrowDownIcon />}
            </IconButton>
          </TableCell>
          <TableCell component="th" scope="row">
            {formatDate(issue?.issueDate)}
          </TableCell>
          <TableCell align="right">{issue?.createdBy}</TableCell>
          <TableCell align="right">{issue?.reason}</TableCell>
          <TableCell align="right">{formatAmount(issue?.systemAmount)}</TableCell>
          <TableCell align="right">{formatAmount(issue?.receiptAmount)}</TableCell>
          <TableCell align="right">{issue?.note}</TableCell>
          <TableCell align="right">
            <IconButton onClick={()=>openImageSlider(issue.receipts)}>
              <ReceiptIcon color='primary'/>
            </IconButton>
          </TableCell>
          <TableCell align="right">
            <IconButton onClick={()=>doneIconClick(issue.id)}>
              <CheckCircleIcon color='success'/>
            </IconButton>
          </TableCell>
        </TableRow>
        <TableRow>
          <TableCell style={{ paddingBottom: 0, paddingTop: 0 }} colSpan={6}>
            <Collapse in={open} timeout="auto" unmountOnExit>
              <Box sx={{ margin: 1 }}>
                <Typography variant="h6" gutterBottom component="div">
                  Order Detail
                </Typography>
                <Table size="small" aria-label="purchases">
                  <TableHead>
                    <TableRow>
                      <TableCell>Order Date</TableCell>
                      <TableCell>Smile Name</TableCell>
                      <TableCell align="right">Link</TableCell>
                      <TableCell align="right">Qty</TableCell>
                      <TableCell align="right">Amount</TableCell>
                      <TableCell align="right">Shipping Fee Jp</TableCell>
                      <TableCell align="right">Weight Price</TableCell>
                      <TableCell align="right">Shipping Fee Th</TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                  {issue.orders.map((order) => {
                    const hasProductPayment = order.OrderReceipts.some(receipt => receipt.amountType === 'productPayment');
                    const hasProductFirst = order.OrderReceipts.some(receipt => receipt.amountType === 'productPaymentFirstHalf');
                    const hasProductSecond = order.OrderReceipts.some(receipt => receipt.amountType === 'productPaymentSecondHalf');
                    const hasShipJpPaidFirst = order.OrderReceipts.some(receipt => receipt.amountType === 'shipJpFirstHalf');
                    const hasShipJpPaidSecond = order.OrderReceipts.some(receipt => receipt.amountType === 'shipJpSecondHalf');
                    const hasShipJpPaid = order.OrderReceipts.some(receipt => receipt.amountType === 'shipJpPaid');
                    const hasShipThPaid = order.OrderReceipts.some(receipt => receipt.amountType === 'shipThPaid');
                    const hasWeightPaid = order.OrderReceipts.some(receipt => receipt.amountType === 'weightPaid');
                    return (
                      <TableRow key={order.uuid}>
                        <TableCell component="th" scope="row">
                          {formatDate(order.orderDate)}
                        </TableCell>
                        <TableCell>{order.smileNameInput}</TableCell>
                        <TableCell align="right">{order.url}</TableCell>
                        <TableCell align="right">{order.qty}</TableCell>
                        <TableCell
                          align="right"
                          style={{ backgroundColor: hasProductPayment || hasProductFirst || hasProductSecond ? 'lightblue' : 'inherit' }}
                        >
                          {order.amount} {hasProductFirst && '(ครึ่งแรก)'}{hasProductSecond && '(ครึ่งหลัง)'}
                        </TableCell>
                        <TableCell
                          align="right"
                          style={{ backgroundColor: hasShipJpPaid || hasShipJpPaidFirst || hasShipJpPaidSecond ? 'lightblue' : 'inherit' }}
                        >
                          {order.deliveryFeeJp} {hasShipJpPaidFirst && '(ครึ่งแรก)'}{hasShipJpPaidSecond && '(ครึ่งหลัง)'}
                        </TableCell>
                        <TableCell
                          align="right"
                          style={{ backgroundColor: hasWeightPaid ? 'lightblue' : 'inherit' }}
                        >
                          {order.weightPrice}
                        </TableCell>
                        <TableCell
                          align="right"
                          style={{ backgroundColor: hasShipThPaid ? 'lightblue' : 'inherit' }}
                        >
                          {order.deliveryFeeTh}
                        </TableCell>
                      </TableRow>
                    );
                  })}
                  </TableBody>
                </Table>
              </Box>
            </Collapse>
          </TableCell>
        </TableRow>
      </React.Fragment>
    );
  }

  return (
    <>
      <Box sx={{ display: 'flex', gap: 1, mb: 1, p: 1 }}>
        <FormControl size="small" sx={{ minWidth: 200 }}>
          <InputLabel>Admin</InputLabel>
          <Select value={adminFilter} label="Admin" onChange={handleAdminChange}>
            <MenuItem value="">All</MenuItem>
            {adminList.map(a => (
              <MenuItem key={a.username} value={a.username}>{a.nickname}</MenuItem>
            ))}
          </Select>
        </FormControl>
      </Box>
      <TableContainer component={Paper}>
        <Modal
          isOpen={modalIsOpen}
          onRequestClose={closeImageSlider}
          style={customStyles}
          ariaHideApp={false}
        >
          <ImageModalSlider imageUrls={imageUrls}/>
        </Modal>
        <Table aria-label="collapsible table">
          <TableHead>
            <TableRow>
              <TableCell />
              <TableCell>Issue Date</TableCell>
              <TableCell align="right">Created By</TableCell>
              <TableCell align="right">Reason</TableCell>
              <TableCell align="right">Amount System</TableCell>
              <TableCell align="right">Amount Transfer</TableCell>
              <TableCell align="right">Note</TableCell>
              <TableCell align="right">Receipt</TableCell>
              <TableCell align="right">Done</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {receiptIssues.map((issue) => (
              <Row key={issue.id} issue={issue} />
            ))}
          </TableBody>
        </Table>
        <TablePagination
          component="div"
          count={total}
          page={page}
          onPageChange={handlePageChange}
          rowsPerPage={rowsPerPage}
          onRowsPerPageChange={handleRowsPerPageChange}
          rowsPerPageOptions={[10, 20, 50]}
        />
      </TableContainer>
    </>
  );
}

export default ReceiptIssue
